// Aides pures de l'écran « Boutiques e-commerce (PrestaShop) » (jumelage, Configuration > Paramètres >
// Intégrations). Aucune dépendance React : testable seule.

// Rôles autorisés à créer, régénérer et détacher : ADMINPAYG (2) et SUPERADMINPAYG (5). Simple confort
// d'affichage : la vraie barrière est le garde de storehouse (403).
const ROLES_ADMIN_COMPTE = [2, 5];
const ROLE_SUPERADMIN = 5;

// Validité d'un code de jumelage (plan §3.1) : 30 minutes.
export const CODE_VALIDITY_MS = 30 * 60 * 1000;

// Intervalle de synchro du stock du connecteur (MJB_STOCK_SYNC_INTERVAL = 300 s) : « en retard »
// au-delà de 3 intervalles.
export const STOCK_SYNC_INTERVAL_MS = 5 * 60 * 1000;

const LEGACY_STORE_ID_RE = /^[a-z0-9_]{3,64}$/;

export function canManageEcomLinks(role) {
    return ROLES_ADMIN_COMPTE.includes(Number(role));
}

export function canSetLegacyStoreId(role) {
    return Number(role) === ROLE_SUPERADMIN;
}

export function isValidLegacyStoreId(value) {
    return LEGACY_STORE_ID_RE.test(value || '');
}

// storehouse rend la liste, brute ou sous { links }.
export function normalizeLinks(body) {
    if (Array.isArray(body)) {
        return body;
    }
    if (body && Array.isArray(body.links)) {
        return body.links;
    }
    return [];
}

// Un jumelage détaché n'est plus une boutique du compte : il n'est pas listé.
export function visibleLinks(links) {
    return (links || []).filter((l) => l && l.state !== 'detached');
}

const STATE_LABELS = {
    pending: 'En attente du module',
    pairing: 'Jumelage en cours',
    active: 'Actif',
    detached: 'Détachée',
};

export function stateLabel(state) {
    return STATE_LABELS[state] || state || 'Inconnu';
}

// Puces Configuré / Actif de l'accordéon, calculées sur les jumelages du compte.
export function linksSummary(links) {
    const list = visibleLinks(links);
    return {
        configured: list.length > 0,
        enabled: list.some((l) => l.state === 'active'),
    };
}

// Les modules e-commerce (produits, photos, contenus PrestaShop) ne s'affichent que si le compte a
// au moins une boutique jumelée active (Configuration > Paramètres > Intégrations).
export function selectEcomActive(state) {
    const ecom = state && state.settings && state.settings.integrations && state.settings.integrations.ecom;
    return linksSummary(ecom && ecom.links).enabled;
}

export function remainingMs(expiresAt, now = Date.now()) {
    const end = Date.parse(expiresAt);
    if (Number.isNaN(end)) {
        return 0;
    }
    return Math.max(0, end - now);
}

// 1800000 -> « 30:00 »
export function formatCountdown(ms) {
    const total = Math.ceil(Math.max(0, ms) / 1000);
    const m = Math.floor(total / 60);
    const s = total % 60;
    return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
}

// État de synchro du lien (ecomStoreSync) : last_stock_sync_at, last_order_at, last_error…
// Seul un lien actif est jugé : « en retard » si aucune synchro de stock depuis 3 intervalles.
export function isSyncLate(link, now = Date.now()) {
    if (!link || link.state !== 'active') {
        return false;
    }
    const sync = link.sync || {};
    const last = Date.parse(sync.last_stock_sync_at);
    if (Number.isNaN(last)) {
        return true;
    }
    return now - last > 3 * STOCK_SYNC_INTERVAL_MS;
}

// Message affichable pour une erreur de l'API (code storehouse ou statut HTTP).
export function ecomErrorMessage(status, body) {
    const code = body && body.code;
    if (code === 'shop_linked_elsewhere') {
        return 'Cette boutique est déjà rattachée à un autre compte.';
    }
    if (code === 'pairing_in_progress') {
        return 'Un jumelage est en cours : attendez 15 minutes avant de générer un nouveau code.';
    }
    if (code === 'link_active') {
        return 'La boutique est active : détachez-la avant de générer un nouveau code.';
    }
    if (code === 'shop_unknown') {
        return 'Magasin inconnu pour ce compte.';
    }
    if (code === 'invalid_legacy_store_id') {
        return 'Identifiant historique invalide (3 à 64 caractères : minuscules, chiffres, _).';
    }
    if (code === 'legacy_store_id_forbidden') {
        return "L'identifiant historique est réservé au superadmin du compte.";
    }
    if (code === 'store_id_exists') {
        return 'Cet identifiant historique existe déjà.';
    }
    if (code === 'connector_url_missing') {
        return "Le connecteur e-commerce n'est pas configuré sur cet environnement.";
    }
    if (status === 403) {
        return 'Action réservée aux administrateurs du compte.';
    }
    if (status === 409) {
        return (body && body.error) || 'Conflit : le jumelage a changé, rechargez la liste.';
    }
    return (body && body.error) || 'Erreur du service boutiques e-commerce';
}
